import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '@/components/atoms/Button';
import { ActiveJob } from '@/hooks/useJobProgress';

interface Props {
  uploadDisabled: boolean;
  handleUpdateCase: () => void;
  isLoading: boolean;
  activeJobs?: ActiveJob[];
  isFormValid?: boolean;
}

export const StartProcessingCase = ({
  uploadDisabled,
  handleUpdateCase,
  isLoading,
  activeJobs,
  isFormValid = true,
}: Props) => {
  const handleStartProcessing = () => {
    handleUpdateCase();
  };

  return (
    <div className="ml-auto flex items-center gap-4">
      <Button
        testid="start-processing-btn"
        onClick={handleStartProcessing}
        loading={isLoading}
        disabled={!isFormValid || uploadDisabled || (activeJobs && activeJobs.length > 0)}
        className="bg-brandSecondary hover:bg-brandSecondary-hover flex items-center justify-center rounded-md px-4 py-2 text-white transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50"
        text="Start Processing"
        iconRight
        icon={<FontAwesomeIcon icon={faArrowRight} className="ml-2 h-4 w-4" />}
      />
    </div>
  );
};
